module.exports = {
	"articleTitle1": "Best Date Spot: The Arb ",
	"catImage": "orangestar.png",
	"totalCats": 3,
	"name": "Nichols Arboretum",
	"bathroomrating": [],
	"articleLink2": "https://www.michigandaily.com/section/columns/michael-sugerman-case-walking-arb",
	"articleSnippet1": "Apr 6, 2016 ... Nichols Arboretum, or the “Arb,” is rated best date spot because it offers a haven \nfrom the constant motion of campus and downtown Ann Arbor, ...",
	"articleSnippet2": "Oct 13, 2016 ... This is the most special time of year in Ann Arbor. The leaves, some of which \nhave begun to fall, are turning the most vibrant shades of autumn.",
	"articleLink1": "https://www.michigandaily.com/section/arts/best-date-spot-arb",
	"articleTitle2": "Michael Sugerman: A case for walking in the Arb ",
	"address": "1610 Washington Heights, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/leg/imagecache/fullnode/tko.ART_.arb_.10-18-12.1107.jpg",
			"caption": "",
			"author": "Tracy Ko"
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160414/sam.bestAAdate.4.7.15.004.jpg?itok=xz_jxOro",
			"caption": "",
			"author": "Sam Mousigian"
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160404/agc.NEW_.RunfortheRed5k.4.2.16.019.jpg?itok=2KGEaynf",
			"caption": "Participants running in the Run for the Red 5k at Nichols Arboretum on Saturday.",
			"author": "Amelia Cacchione/Daily"
		}
	],
	"position": {
		"lat": 42.280613,
		"lng": -83.726916
	},
	"tips": [
		{
			"text": "There are so many nice places to hammock in the Arb. You can't go wrong with where in the Arb you decide on.",
			"person": "Erik Forkin"
		},
		{
			"text": "There' a natural track in the grass. Each \"lap\" is about 1/5 a mile. If you're running/walking with headphones be careful because you can unknowingly get really close to deer.",
			"person": "Shivangi Sharma"
		},
		{
			"text": "There is a big field in the middle of the Arb that is great for sunbathing and throwing the frisbee around.",
			"person": "Erik Forkin"
		}
	],
	"totalMisc": 3,
	"categories": {
		"yogaspot": 1,
		"bestofaa": 1,
		"sunbathingspot": 1,
		"studyspot": 1,
		"pickupsports": 1,
		"recarea": 1,
		"datespot": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/arb.json
// module id = 812
// module chunks = 0